module.exports = __webpack_public_path__ + "img/sdg_en_(12).80813342.png";